import React, { ReactNode } from 'react';
import { Environment } from '../../../interfaces/backend/Environments';
import { Notification } from '../../../interfaces/backend/Notification';
import { User } from '../../../interfaces/backend/User';
import { CodeType } from '../CodeType';
import Loading from '../../loading';

export type UserObject = Pick<User, 'id' | 'email' | 'number'>;

export interface BuildCodeParams {
  environment: Environment;
  notification: Notification;
  user: UserObject;
  mergeTags: Record<string, unknown>;
}

export abstract class CodeSample {
  abstract readonly name: string;
  abstract readonly language: string;
  abstract readonly codeType: CodeType;
  abstract readonly tabIcon: string;
  abstract readonly commentChar?: string;

  protected abstract buildCode(params: BuildCodeParams): ReactNode;

  renderCode(params: Partial<BuildCodeParams>): ReactNode {
    if (!params.environment || !params.notification) {
      return <Loading />;
    }

    return this.buildCode(params as BuildCodeParams);
  }
}
